import React from "react";
import "./FastCasinoGameDevelopmentServicesStyle.scss";
import { fastCasinoGameDevelopmentServicesTextContent } from "./constant/index";
import SectionHeading from "../Common_UI_Kit/SectionHeading";

const FastCasinoGameDevelopmentServicesSection = () => {
  return (
    <section className="fast-casino-game-development-services-section">
      <div className="fast-casino-game-development-services-wrap">
        <SectionHeading>{fastCasinoGameDevelopmentServicesTextContent.headingText}</SectionHeading>

        <div className="fast-casino-game-development-services-box">
          <div className="cards-grid">
            {fastCasinoGameDevelopmentServicesTextContent.content.map((section, index) => (
              <div className="card" key={index}>
                <div className="card-header">
                  <div className="icon-box">
                    <img src={section.iconSrc} alt="Image" />
                  </div>
                  <h5 className="title-text">{section.titleText}</h5>
                </div>

                <div className="card-body">
                  <p className="para-text">{section.paraText}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default FastCasinoGameDevelopmentServicesSection;
